module.exports = __webpack_public_path__ + "img/send-password.7350c010.png";